import ServiceApi from "../services/service.api";
const baseServiceUrl = `/api/v1/PageContent`;


const ApiPageContent = {
  getAllPageContent: (params) => {
    const url = `${baseServiceUrl}/GetAllPageContent`;
    return ServiceApi.get(url, { params });
  },
  getPageContentById: (params) => {
    const url = `${baseServiceUrl}/GetPageContentById`;
    return ServiceApi.get(url, { params });
  },
  createPageContent: (params) => {
    const url = `${baseServiceUrl}/CreatePageContent`;
    return ServiceApi.post(url, params);
  },
  updatePageContent: (params) => {
    const url = `${baseServiceUrl}/UpdatePageContent`;
    return ServiceApi.put(url, params);
  },
};

export default ApiPageContent;